"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
var _utils = require("../../../../utils");
const color = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  code = code.toLowerCase();
  switch (code) {
    case 'general':
      return '#2ED300';
    case 'hail':
      return '#EBE100';
    case 'rotating':
      return '#F17200';
    case 'tornado':
      return '#FF2600';
    default:
      return '#000000';
  }
};
/**
 * @private
*/
const config = exports.config = {
  data: {
    request: {
      endpoint: 'stormcells'
    },
    properties: {
      id: 'id',
      path: 'forecast.cone.wide',
      category: 'traits.type',
      timestamp: 'ob.timestamp'
    },
    reversedCoord: true
  },
  style: {
    marker: data => {
      const type = (0, _utils.get)(data, 'traits.type');
      return {
        className: 'marker-stormcell',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: color(type)
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [12, 12]
      };
    },
    polygon: data => {
      const type = (0, _utils.get)(data, 'traits.type');
      return {
        fill: {
          color: color(type),
          opacity: 0.5
        }
      };
    }
  }
};
var _default = exports.default = config;